import { j as t } from "../../../jsx-runtime-BwWtxLpl.js";
import h, { useContext as i } from "react";
import o from "prop-types";
import x from "classnames";
import { ModalContext as j } from "../modal.context.js";
import "../../button/button.js";
import "../../dropdown-portal/dropdown-portal.js";
import { MotifIcon as C } from "../../icon/icon.js";
import { IconContext as b } from "../../icon/icon.context.js";
import { IconoirXmark as M } from "@ey-xd/motif-icon";
import { MotifIconButton as N } from "../../button/icon-button/icon-button.js";
const k = {
  close: M
}, y = ({
  children: m,
  className: n = "",
  closeModalButton: l = null,
  closeButtonProps: c = {},
  icons: r = {},
  headerIcon: e = null,
  ...d
}) => {
  const f = i(j), { modalHeader: a } = i(b);
  let s;
  a ? s = {
    ...a,
    ...r
  } : s = {
    ...k,
    ...r
  };
  const p = () => {
    f.closeModal();
  }, u = x({
    "motif-modal-header": !0,
    "motif-modal-header-fab": e,
    "sb-unstyled": !0,
    [n]: !0
  });
  return /* @__PURE__ */ t.jsxs("div", { ...d, className: u, "data-motif-modal-header": !0, children: [
    /* @__PURE__ */ t.jsx("h3", { className: "motif-h3 motif-modal-headline", children: m }),
    /* @__PURE__ */ t.jsxs("div", { className: e && "motif-modal-header-icons", children: [
      e || null,
      l ? /* @__PURE__ */ t.jsx(h.Fragment, { children: l }) : /* @__PURE__ */ t.jsx(
        N,
        {
          "aria-label": "Click here to close modal",
          type: "button",
          onClick: p,
          className: "motif-modal--header-icon-button",
          "data-testid": "close-modal",
          ...c,
          children: /* @__PURE__ */ t.jsx(C, { iconFunction: s.close, strokeWidth: "0", fill: "currentColor" })
        }
      )
    ] })
  ] });
};
y.propTypes = {
  children: o.node,
  className: o.string,
  closeModalButton: o.node,
  closeButtonProps: o.instanceOf(Object),
  icons: o.shape({
    close: o.node
  }),
  headerIcon: o.node
};
export {
  y as MotifModalHeader
};
